export const reservationConversations = {
  tabs: {
    calls: "Appels",
    web: "Web",
    checkins: "Check-ins",
    charges: "Frais",
    notes: "Notes",
  },
  checkinBadge: {
    allCompleted: "Tous les check-ins terminés",
    manuallyResolved: "Remise finale effectuée manuellement par un opérateur",
    progress: "{done}/{total} check-ins terminés",
  },
  banners: {
    limitedMode:
      "Cette réservation n'est pas configurée pour le flux complet. Vous pouvez uniquement utiliser WhatsApp et les notes internes.",
    rejectedMode:
      "La demande a été refusée. Seuls WhatsApp et les notes internes restent disponibles.",
    autoReplying: "L'agent répond automatiquement.",
  },
  search: {
    placeholder: "Rechercher par nom, téléphone ou code de réservation...",
  },
  list: {
    emptyTitle: "Aucune conversation pour le moment",
    emptyText:
      "Lorsque le voyageur écrit ou que vous envoyez un message, la conversation apparaît ici.",
    noResultsTitle: "Aucune conversation trouvée",
    noResultsText: "Essayez un autre nom, téléphone ou code de réservation.",
    aiActiveTitle: "Agent IA actif",
    markAllRead: "Tout marquer comme lu",
  },
  conversation: {
    windowTimer: "Fenêtre de messagerie : {hours}h restantes",
    copyPortalCopied: "Lien copié",
    copyPortalTooltip: "Copier le lien de gestion",
    copiedShort: "Copié",
    copyLinkShort: "Copier le lien",
    dropToAttach: "Déposez pour joindre les fichiers",
    senderBot: "BOT / ÉQUIPE",
    senderGuest: "VOYAGEUR",
    imageAlt: "Image envoyée",
    locationReceived: "Localisation reçue",
    viewFile: "Voir le fichier",
    notSent: "Non envoyé",
    sending: "Envoi...",
    emptyTitle: "Aucun message pour le moment",
    emptyText:
      "Démarrez la conversation avec un modèle ou attendez que le voyageur écrive.",
  },
  mode: {
    ai: "IA",
    manual: "Manuel",
    agentInactiveTooltip:
      "L'agent IA n'est pas actif pour cet établissement. Activez-le dans les paramètres de l'annonce pour qu'il réponde automatiquement.",
    agentInactiveChip: "Agent IA inactif",
  },
  composer: {
    predefinedTitle: "Réponses prédéfinies",
    predefinedEmpty: "Aucune réponse prédéfinie trouvée",
    attachFile: "Joindre un fichier",
    inputPlaceholder: "Commencez par / pour sélectionner une réponse prédéfinie.",
    removeFile: "Supprimer le fichier",
    fileFallback: "fichier",
  },
  calls: {
    title: "Appels pour cette réservation",
    none: "Aucun appel lié à cette réservation.",
    caller: "Appelant",
    bookedFromCall: "Réservé à partir de cet appel",
    pause: "Pause",
    play: "Lecture",
    downloadMp3: "Télécharger le MP3",
    noRecording: "Aucun enregistrement",
  },
  ota: {
    noData: "Aucune donnée de réservation pour charger les messages OTA.",
  },
  checkins: {
    title: "Check-ins de la réservation",
  },
  charges: {
    title: "Frais de la réservation",
    noData: "Aucune donnée de réservation pour charger les frais.",
  },
  notes: {
    title: "Notes internes",
    noData: "Aucune donnée de réservation pour charger les notes.",
  },
  time: {
    today: "Aujourd'hui {time}",
    yesterday: "Hier {time}",
  },
  guestFallback: "Voyageur",
  webGuestFallback: "Voyageur",
  documentFallback: "Document",
  location: {
    openInMaps: "Ouvrir dans Google Maps",
    viewCoords: "Voir les coordonnées ({lat}, {lng})",
  },
  delivery: {
    read: "Lu",
    delivered: "Distribué",
    queued: "En file d'attente",
    failed: "Échec",
    sent: "Envoyé",
  },
  errors: {
    genericSendFail: "Ce message n'a pas pu être envoyé via WhatsApp.",
  },
  failureShort: {
    paymentIssue: "problème de paiement sur le compte WhatsApp",
    cannotReceive: "le numéro ne peut pas recevoir de messages WhatsApp",
    downloadFailed: "WhatsApp n'a pas pu télécharger le fichier",
    templateMissingData: "données de modèle manquantes",
    requirementsNotMet: "le message ne respecte pas les exigences de WhatsApp",
  },
  failureTitle: {
    noWhatsapp: "Pas de WhatsApp",
    invalidNumber: "Numéro invalide",
    notSent: "Non envoyé",
  },
  alerts: {
    paymentIssue: "Problème de paiement sur WhatsApp",
    whatsappUnavailable: "WhatsApp indisponible",
    qualityReduced: "Qualité du numéro réduite",
  },
  toast: {
    reactivateNoConv: "Impossible d'identifier la conversation à réactiver.",
    templateSent: "Modèle envoyé avec succès.",
    reactivateFail: "Impossible d'envoyer le modèle de réactivation.",
    cannotSendWhatsappTitle: "Impossible d'envoyer via WhatsApp",
    invalidPhoneDetail:
      "Le téléphone de cette réservation ({phone}) n'est pas un numéro valide. Corrigez-le dans « Modifier la réservation » pour lui écrire.",
    noPhoneDetail:
      "Cette réservation n'a pas de téléphone. Ajoutez-le dans « Modifier la réservation » pour lui écrire.",
    sendErrorTitle: "Erreur d'envoi",
    sendErrorDetail: "Le message n'a pas pu être envoyé",
    errorTitle: "Erreur",
    copyLinkFail: "Impossible de copier le lien",
    agentInactiveTitle: "Agent IA inactif",
    agentInactiveDetail:
      "Cet établissement n'a pas l'agent IA activé. Activez-le dans les paramètres de l'annonce.",
    noConvId: "Impossible d'identifier la conversation",
    modeChangeFail: "Impossible de changer le mode de discussion",
    agentUnavailableTitle: "Agent IA indisponible",
  },
};
